var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDestinoLixo = function SvgDestinoLixo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C9 2.667 9.667 2 11 2H13C14.333 2 15 2.667 15 4H18C19.333 4 20 4.667 20 6V8H4V6C4 4.667 4.666 4 5.999 4H9ZM19 10V20C19 21.333 18.333 22 17 22H7C5.664 22 4.997 21.333 5 20V10H19ZM9 14V18C9 18.667 9.333 19 10 19C10.667 19 11 18.667 11 18V14C11 13.324 10.667 12.99 10 13C9.333 13.01 9 13.343 9 14ZM13 14V18C13 18.667 13.333 19 14 19C14.667 19 15 18.667 15 18V14C15 13.324 14.667 12.99 14 13C13.333 13.01 13 13.343 13 14Z",
    fill: "#3A3A47"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDestinoLixo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/destino-lixo.b0fa0c9e.svg";
export { ForwardRef as ReactComponent };